// extracted by mini-css-extract-plugin
export default {"footerOuter":"Footer_Admin_footerOuter__Pa9JO","divider":"Footer_Admin_divider__Zk7Zs","link":"Footer_Admin_link__FYdJR","text":"Footer_Admin_text__KmwRg"};